import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { PorteEmpresaFormControlComponent } from './porte-empresa-form-control.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        PorteEmpresaFormControlComponent
    ],
    exports: [
        PorteEmpresaFormControlComponent
    ]
})
export class PorteEmpresaFormControlModule { }
